module.exports = __webpack_public_path__ + "img/report-icon-active.a3dcb42e.svg";